// extracted by mini-css-extract-plugin
module.exports = {"hillContainer":"datahills-module--hillContainer--w780p","hide":"datahills-module--hide---UVz_"};